import * as React from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { InvestmentAssetClassAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentAssetClassAllocationModel";

interface IAssetAllocationChart {
    data: InvestmentAssetClassAllocationModel;
}

const colors = [
    "#0057B7",
    "#72246C",
    "#008264",
    "#E24082",
    "#000000",
    "#EBECEE",
    "#D9D9D6",
    "#00205B",
    "#41273B",
    "#00594C",
    "#BC0056",
    "#898D8D",
    "#424242",
    "#B2BABF",
    "#00C1D4",
    "#00B74F",
    "#963CBD",
    "#EF2B35",
    "#A7A8A9",
    "#DDE5ED",
];

export const AssetAllocationChart = (props: IAssetAllocationChart) => {
    const _data = props.data.AssetClassAllocationSummary.concat();
    if (!_data || _data.length == 0) {return null;}

    const Data = _data.map((ele) => {
        return {
            name: ele.DisplayName,
            color: null,
            y: Number(ele.Allocation.toFixed(2)),
        };
    });

    const options: Highcharts.Options = {
        chart: {
            renderTo: "container",
            type: "pie",
            backgroundColor: "var(--panel-heavy)",
        },
        colors: colors,
        title: {
            text: "",
        },
        navigator: {
            enabled: false,
        },
        rangeSelector: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: "Total percent market share",
            },
        },
        plotOptions: {
            pie: {
                shadow: false,
            },
        },
        tooltip: {
            formatter: function () {
                return "<b>" + this.point.name + "</b>: " + this.y + " %";
            },
        },
        series: [
            {
                name: "Asset Classes",
                type: "pie",
                data: Data,
                size: "80%",
                innerSize: "93%",
                selected: false,
                showInLegend: false,
                dataLabels: {
                    enabled: false,
                },
            },
        ],
    };

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-5 text-center pt-10">
                    {/* <DonutChart data={donutData} thickness={9} size={320} /> */}
                    <HighchartsReact highcharts={Highcharts} options={options} />
                </div>
                <div className="col-12 col-md-7">
                    <table className="data-table asset-class-table">
                        <thead>
                            <tr>
                                <th>Asset class</th>
                                <th className="cell-right">Allocation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_data.map((row, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span
                                                className="product-color"
                                                aria-hidden={true}
                                                style={{ borderColor: colors[index] }}
                                            ></span>
                                            {row.DisplayName}
                                        </td>
                                        <td className="cell-right">{row.Allocation.toFixed(2)}%</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};
